export default __webpack_public_path__ + "6c0fd38753d069b9a5820196a95cbea2.svg";